export const BRAINTREE_FIELD_IDS = {
  CARD_NUMBER: 'braintree-card-number',
  EXPIRATION_DATE: 'braintree-expiration-date',
  CVV: 'braintree-cvv',
  CARDHOLDER_NAME: 'braintree-cardholder-name',
} as const;

export const BRAINTREE_FIELD_CONFIG = {
  number: {
    selector: `#${BRAINTREE_FIELD_IDS.CARD_NUMBER}`,
    placeholder: 'Card Number',
  },
  expirationDate: {
    selector: `#${BRAINTREE_FIELD_IDS.EXPIRATION_DATE}`,
    placeholder: 'MM/YY',
  },
  cvv: {
    selector: `#${BRAINTREE_FIELD_IDS.CVV}`,
    placeholder: 'CVV',
  },
  cardholderName: {
    selector: `#${BRAINTREE_FIELD_IDS.CARDHOLDER_NAME}`,
    placeholder: 'Cardholder Name',
  },
} as const;

export const BRAINTREE_STYLES = {
  input: {
    'font-size': '14px',
    color: 'inherit',
    padding: '12px 8px',
  },
  'input:focus': {
    outline: 'none',
  },
  ':focus': {
    'border-color': 'var(--color-muted-foreground, #71717A)',
  },
  ':active': {
    'border-color': 'var(--color-muted-foreground, #71717A)',
  },
  '::placeholder': {
    color: 'rgb(156, 163, 175)',
  },
} as const;

export const BRAINTREE_ERROR_CODES = {
  DUPLICATE_IFRAME: 'HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME',
  TIMEOUT: 'HOSTED_FIELDS_TIMEOUT',
} as const;

export const BRAINTREE_HOSTED_FIELD_NAMES = {
  CARD_NUMBER: 'number',
  EXPIRATION_DATE: 'expirationDate',
  CVV: 'cvv',
} as const;

export const BRAINTREE_DOM_READY_DELAY = 100;

export const VENMO_CONFIG = {
  allowNewBrowserTab: false,
  allowDesktop: true,
  allowDesktopWebLogin: false,
  allowWebviews: false,
  mobileWebFallBack: false,
  paymentMethodUsage: 'multi_use' as 'multi_use' | 'single_use',
};
